var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pt-[70px]",attrs:{"id":"app"}},[_c('Navbar',{attrs:{"auth":_vm.$auth,"locale-switcher":true}}),_vm._v(" "),_c('main',{staticClass:"relative p-3 pr-5 min-h-full"},[_c('Nuxt'),_vm._v(" "),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }